import type { GenericTableColumn } from 'inside-fifa/api/generic-tables/dto';

export enum GenericTableColumnAppearance {
    ShowColumn,
    Hide,
    Responsive,
    ShowInExpandedRow,
    ShowFullWidthRow,
}

export type AppearanceCellProps = {
    column: GenericTableColumn;
    onChange: (newColumn: GenericTableColumn) => void;
};
